import withErrorBoundary from "../../../../../../hocs/guards/withErrorBoundary"
import useCreator from "../../../../../../hooks/useCreator"
import { useDispatch, useSelector } from "react-redux"
import {
  addKnowmixMember,
  clearKnowmixMembersList,
  deleteKnowmixMember,
  knowmixMembersList,
} from "../../../../../../library/store/actions/creators/knowmixCreators"
import ListPage from "../../../../../../components/v2/layout/listPage/listPage"
import UserCard from "../../../../../../components/v2/layout/cards/userCard"
import { getObjectById } from "../../../../../../library/utils/arrays"
import { calendarGrades } from "../../../../../../library/constants/educationalDictionary"
import { safeGetEntity } from "../../../../../../library/utils/entities"

const KnowmixSettingsMembers = () => {
  const creator = useCreator()
  const dispatch = useDispatch()

  const { currentKnowmix, membersList, membersListEndReached } = useSelector(
    ({ knowmix }) => knowmix
  )

  const addMember = async (id) =>
    await creator(
      addKnowmixMember({
        user_id: id,
        knowmix_id: currentKnowmix.id,
      })
    )
  const removeMember = async (id) =>
    await creator(
      deleteKnowmixMember({
        user_id: id,
        knowmix_id: currentKnowmix.id,
      })
    )

  return (
    <ListPage
      title={"Members"}
      noResultsLabel={`Chosen schedule doesn't have students for ${
        safeGetEntity(currentKnowmix.subject)
          ? getObjectById(calendarGrades, currentKnowmix.subject.grade).name
          : "this"
      } grade`}
      getList={async ({ name, offset }) => {
        await dispatch(
          knowmixMembersList({
            knowmix_id: currentKnowmix.id,
            group_id: currentKnowmix.creator_group.id,
            // grade: currentKnowmix.subject.grade,
            name,
            offset,
          })
        )
      }}
      clearList={() => dispatch(clearKnowmixMembersList())}
      list={membersList}
      listEndReached={membersListEndReached}
      getListItemComponent={({ item }) => (
        <UserCard
          user={item}
          infoComponent={() => (
            <p>Grade: {getObjectById(calendarGrades, item.grade).name}</p>
          )}
          controls={
            item?.knowmix.is_member
              ? {
                  button: {
                    label: "Remove",
                    action: () => removeMember(item.id),
                  },
                }
              : {
                  button: {
                    label: "Add",
                    action: () => addMember(item.id),
                  },
                }
          }
        />
      )}
    />
  )
}

export default withErrorBoundary(KnowmixSettingsMembers)
